/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {Zone} from "../models/zone";
import {ZoneService} from "../services/zone.service";
import { Input, Injectable } from "@angular/core";
import {Resolve, ActivatedRouteSnapshot, RouterStateSnapshot} from "@angular/router";

@Injectable()
@Input()
export class ZonesResolver implements Resolve<Zone[]> {

  constructor(
    private mZoneService: ZoneService
  ) {}

  async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<Zone[]> {
    try {
      return await this.mZoneService.getAllZones();
    } catch (error) {
      console.error("Problem resolving Zones... Error: " + error, error);
    }
  }

}
